import { createGeneralPageEventsAndComponents } from "../technical/page-general";
import { createHomepageElements } from "../technical/homepage-elements";
import { expressQuerySelector, expressQuerySelectorAll } from "../../common/html";
import { initPagedShowMoreElements } from "../technical/show-more-elements";
import { createFaq } from "../technical/faq";

document.addEventListener("DOMContentLoaded", async () => {
	createGeneralPageEventsAndComponents();
	await createHomepageElements();

	const faqs = expressQuerySelectorAll<HTMLElement>(document, ".technical-faq-container");
	faqs.forEach((faqEl) => {
		createFaq(faqEl);

		const buttonEl = expressQuerySelector<HTMLElement>(faqEl, ".technical-showmore-button", false);
		if (buttonEl) {
			initPagedShowMoreElements(faqEl, buttonEl, null, ".technical-showmore-faq", 0);
		}
	});
});
